import React, { useEffect, useRef, useState } from "react";
import { SearchContainer } from "../styled/shop";
import ShopSearchMap from "./shopSearch/shopSearchMap";
import ShopSearchBanner from "./shopSearch/shopSearchBanner";
import ShopSearchForm from "./shopSearch/shopSearchForm";
import axios from "axios";

const ShopSearch = ({ store, cmpnyIntroduce }) => {
  const [isSearch, setIsSearch] = useState(false);
  const [searched, setSearched] = useState("");
  const [products, setProduct] = useState([]);
  const [findStore, setFindStore] = useState([]);
  const [center, setCenter] = useState({ lat: 36.348768969298746, lng: 127.39696329741778 });
  const [userLocation, setUserLocation] = useState(null);

  const mapRef = useRef(null);

  useEffect(() => {
    setFindStore([...store, ...cmpnyIntroduce]);
  }, [store, cmpnyIntroduce]);

  useEffect(() => {
    let isActive = true;
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          if (isActive) {
            const location = {
              lat: position.coords.latitude,
              lng: position.coords.longitude,
            };
            setCenter(location);
            setUserLocation(location);
          }
        },
        (error) => {
          console.error("Geolocation error:", error);
        },
        { enableHighAccuracy: true, timeout: 20000, maximumAge: 1000 },
      );
    }

    return () => {
      isActive = false;
    };
  }, []);

  useEffect(() => {
    if (window.naver && window.naver.maps && mapRef.current) {
      mapRef.current.panTo(new window.naver.maps.LatLng(center.lat, center.lng));
    }
  }, [center]);

  const searchProducts = async () => {
    const url = "/erp/vendorProducts/get";
    const query = `
      query VendorProducts($name: String) {
        vendorProducts(filter: { name: $name }) {
          totalCount
          products {
            cmpnyNo
            name
            media
          }
        }
      }
    `;

    const body = { query, variables: { name: searched } };
    try {
      const res = await axios.post(url, body);
      if (res.status === 200) {
        if (!isSearch) setIsSearch(true);

        const rawProducts = res?.data?.products || [];
        const enrichedProducts = mergeCompanyInfo(rawProducts, [...store, ...cmpnyIntroduce]);

        setProduct(enrichedProducts);
        findCompany(enrichedProducts);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const findCompany = (products) => {
    const filteredStores = [...store, ...cmpnyIntroduce].filter((sto) =>
      products.some((item) => item.cmpnyNo === sto.cmpnyNo),
    );

    setFindStore(filteredStores);
    getClosestStore(filteredStores);
  };

  const mergeCompanyInfo = (products, companyList) => {
    return products
      .map((product) => {
        const company = companyList.find((c) => c.cmpnyNo === product.cmpnyNo);
        if (!company) return null;
        return {
          ...product,
          company,
        };
      })
      .filter(Boolean);
  };

  const getClosestStore = (stores) => {
    if (!userLocation || stores.length === 0) return null;

    const getDistance = (lat1, lng1, lat2, lng2) => {
      const toRad = (v) => (v * Math.PI) / 180;
      const R = 6371;
      const dLat = toRad(lat2 - lat1);
      const dLng = toRad(lng2 - lng1);
      const a =
        Math.sin(dLat / 2) ** 2 +
        Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLng / 2) ** 2;
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      return R * c;
    };

    setCenter(
      ((s) => ({ lat: s.lat, lng: s.lng }))(
        stores.reduce((prev, curr) => {
          const prevDist = getDistance(userLocation.lat, userLocation.lng, prev.lat, prev.lng);
          const currDist = getDistance(userLocation.lat, userLocation.lng, curr.lat, curr.lng);
          return currDist < prevDist ? curr : prev;
        }),
      ),
    );
  };

  const clickProduct = (product) => {
    const target = [...store, ...cmpnyIntroduce].find((sto) => product.cmpnyNo === sto.cmpnyNo);
    if (target) {
      setCenter({ lat: Number(target.latitude), lng: Number(target.longitude) });
    }
  };

  return (
    <SearchContainer>
      <ShopSearchForm
        searched={searched}
        setSearched={setSearched}
        searchProducts={searchProducts}
      />
      <ShopSearchMap
        isSearch={isSearch}
        store={store}
        findStore={findStore}
        mapRef={mapRef}
        center={center}
        setCenter={setCenter}
        userLocation={userLocation}
      />
      {isSearch && <ShopSearchBanner products={products} clickProduct={clickProduct} />}
    </SearchContainer>
  );
};

export default ShopSearch;
